
import './IgongChartScore.scss';
import fnc from '../mymod/commFunction';
import * as S from '../scss/theme';
import React, { useState, useEffect } from 'react';

const IgongChartScore = ({data}) => {

    const [list, setList] = useState([]);


    useEffect(() => {

        console.log(data, '============= data');
        if (data.length > 0) {
           
        }
       

      
    }, [data]);
       

//=========================================
  return (
    <div className='IgongChartScore'>
        <article className='art-main'>
            <table className='table-hong'>   
                <thead>
                    <tr>
                        <th>구분</th>
                        <th>{data[0].subject}</th>
                        <th>{data[2].subject}</th>
                        <th>{data[3].subject}</th>
                        <th>{data[1].subject}</th>
                    </tr>
                </thead>

                <tbody >        
                  
                    <tr> 
                        <td>학부모</td>
                        <td>{data[0].parent}</td>
                        <td>{data[2].parent}</td> 
                        <td>{data[3].parent}</td> 
                        <td>{data[1].parent}</td>       
                    </tr>   

                    <tr>
                        <td>학생</td>    
                        <td>{data[0].student}</td>
                        <td>{data[2].student}</td> 
                        <td>{data[3].student}</td> 
                        <td>{data[1].student}</td>    
                    </tr>  

                </tbody>
            </table>
  
        </article>

    </div>
  );
};

export default IgongChartScore;